import type { JournalItem } from "@nabla/api";

const registro = (nome: string, video: boolean, conjunto: string) =>
  `${nome} preparou ${video ? "um vídeo" : "uma imagem"} para uma campanha nova nas configurações de ${conjunto}.`;
const anexado = (nome: string, video: boolean) =>
  `${nome} anexou ${video ? "um vídeo" : "uma imagem"} para uma campanha nova, numa conversa.`;

export function journal(item: JournalItem, actor: string): string | undefined {
  if (item.type === "arquivo-anexado") return anexado(actor, item.file.kind === "video");
  return item.type === "arquivo-campanha" ? registro(actor, item.file.kind === "video", item.object?.name ?? "") : undefined;
}
